import type { EcommerceItemType } from '@lichtblick/tracker';
import { Categories, PeriodUnit, type TariffsQuery } from '../types/generated';

export type EcommerceTrackingTariff = TariffsQuery['tariffs'][number] & {
  itemIndex?: number;
};

const UNUSED_CATEGORIES = {
  [Categories.Article]: '',
  [Categories.Eaas]: '',
  [Categories.Fahrstrom]: '',
  [Categories.Power2Car]: '',
  [Categories.Service]: '',
  [Categories.Unknown]: '',
} as const;

const E_COMMERCE_TRACKING_CATEGORY: Record<Categories, string> = {
  ...UNUSED_CATEGORIES,
  [Categories.Power]: 'B2C Electricity',
  [Categories.Gas]: 'B2C Gas',
  [Categories.Heatpump]: 'B2C Heating',
  [Categories.Storageheater]: 'B2C Heating',
  [Categories.Spot]: 'B2C Electricity',
  [Categories.Dynamictariff]: 'B2C Dynamic',
};

const E_COMMERCE_TRACKING_LIST_NAME: Record<Categories, string> = {
  ...UNUSED_CATEGORIES,
  [Categories.Power]: 'B2C Electricity',
  [Categories.Gas]: 'B2C Gas',
  [Categories.Heatpump]: 'Wärmepumpe',
  [Categories.Storageheater]: 'Nachtspeicherheizung',
  [Categories.Spot]: 'B2C Electricity',
  [Categories.Dynamictariff]: 'B2C Dynamic',
};

export const calculateEnergyProductPrice = (tariff: TariffsQuery['tariffs'][number]): number => {
  const bonus = tariff.bonus?.absolute ?? 0;
  const monthlyRate = tariff.monthlyRate ?? 0;

  let factor: number = 1;
  let adjustedContractPeriod = tariff.contractPeriod?.value ?? NaN;

  if (tariff.contractPeriod?.value ?? 0) {
    if (tariff.contractPeriod?.unit === PeriodUnit.Days) {
      factor = 30;
    } else if (tariff.contractPeriod?.unit === PeriodUnit.Weeks) {
      factor = 4;
    }
  }

  if (tariff.contractPeriod?.value === 0) {
    adjustedContractPeriod = 1;
  }

  return monthlyRate * (adjustedContractPeriod / factor) - bonus;
};

export const getGasTariffIndex = (cardIndex: number, activeIndex: number, tariffsCount: number): number => {
  return activeIndex === 1 ? cardIndex + tariffsCount : cardIndex;
};

export const createEcommerceItem = (
  tariffs: EcommerceTrackingTariff[],
  loggedIn: boolean,
  isComboCheckout?: boolean,
): EcommerceItemType => ({
  currency: 'EUR',
  bundle_intention: isComboCheckout ?? false,
  items: tariffs.map((tariff, index) => ({
    item_name: tariff.name ?? '',
    item_id: tariff.productCode ?? '',
    index: (tariff.itemIndex ? tariff.itemIndex : index) + 1,
    item_category: `${loggedIn ? 'SV ' : ''}${E_COMMERCE_TRACKING_CATEGORY[tariff.productCategory]}`,
    item_list_name: E_COMMERCE_TRACKING_LIST_NAME[tariff.productCategory],
    price: calculateEnergyProductPrice(tariff),
  })),
});
